import { FC, memo } from 'react'
import { FormInstance, Select } from 'antd'
import FormItem from 'antd/es/form/FormItem'
import spclasses from '../SetCourseClassDirectionModal/purchase.module.css'
import { ICustomCourse } from '../SetCourseClassDirectionModal/SetCourseModalBody'
import EnrollDateCheckbox from './EnrollDateCheckbox'
import { RequestCreateLeadPaymentLink } from '@/api/types/crm/crm.types'
import { useWatch } from 'antd/es/form/Form'
import {
  PAYMENT_LINK_TARIFF_TYPES,
  getCrmLinkTariffTypeLabel,
} from './tariffTypes'

type FieldType = Omit<RequestCreateLeadPaymentLink, 'lead_funnel_id'>

export interface CourseFieldsProps {
  form: FormInstance<any>
  selectedCourse?: ICustomCourse
  coursesState: { value?: ICustomCourse[]; loading: boolean }
  filterSort: (optionA: any, optionB: any) => number
  hideEnrollDate?: boolean
  // tariffOptions: { label: string; value: number | null }[]
}

const CourseFields: FC<CourseFieldsProps> = memo((props) => {
  const { coursesState, filterSort, selectedCourse, form, hideEnrollDate } =
    props

  const tariffOptions =
    selectedCourse?.directionTariffs
      ?.filter((tariff) => PAYMENT_LINK_TARIFF_TYPES.includes(tariff?.type))
      ?.map((tariff) => ({
        label: tariff.name || `Тариф ${tariff.id}`,
        value: tariff.id,
      })) ?? []

  const tariffIdWatch = useWatch('tariff_id', form) as number | null
  const selectedTariff = selectedCourse?.directionTariffs.find(
    (item) => item.id === tariffIdWatch,
  )
  const tariffTypeLabel = getCrmLinkTariffTypeLabel(selectedTariff?.type)

  return (
    <>
      <div className={spclasses.inputWithLabel}>
        <div className={spclasses.inputLabel}>Курс</div>
        <FormItem<FieldType>
          name="course_id"
          rules={[{ required: true, message: 'выберите курс' }]}
          noStyle
        >
          <Select
            showSearch
            className={spclasses.select}
            placeholder="Выберите курс"
            optionFilterProp="label"
            filterSort={filterSort}
            loading={coursesState.loading}
            options={coursesState.value?.map(({ name: label, id: value }) => ({
              label,
              value,
            }))}
          />
        </FormItem>
      </div>
      <div className={spclasses.inputWithLabel}>
        <div className={spclasses.inputLabel}>Тариф</div>
        <FormItem<FieldType>
          name="tariff_id"
          rules={[{ required: true, message: 'выберите тариф' }]}
          noStyle
        >
          <Select
            showSearch
            className={spclasses.select}
            placeholder="Выберите тариф"
            optionFilterProp="label"
            filterSort={filterSort}
            options={tariffOptions}
          />
        </FormItem>
        {tariffTypeLabel ? (
          <div className={spclasses.tariffTypeHint}>
            Тип тарифа: {tariffTypeLabel}
          </div>
        ) : null}
      </div>
      {!hideEnrollDate &&
        selectedTariff?.type &&
        [
          'month',
          'stream_custom_period',
          'stream_custom_days',
          'stream_custom_weeks',
        ].includes(selectedTariff.type) && (
          <div className={spclasses.inputWithLabel}>
            <FormItem<FieldType> name="enroll_date" noStyle>
              <EnrollDateCheckbox />
            </FormItem>
          </div>
        )}
    </>
  )
})

export default CourseFields
